import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';

@Component({
  selector: 'app-resetpassword',
  templateUrl: './resetpassword.component.html',
  styleUrls: ['./resetpassword.component.css']
})
export class ResetpasswordComponent implements OnInit {

  user: any = {};
  token: string;
  constructor(private route: ActivatedRoute, private loginservice: LoginService,
    private _flashMessagesService: FlashMessagesService) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.token = params.id;
    }, error => { alert('Network Error params API'); });

    // this.loginservice.verifyToken(this.token)
    //   .subscribe(
    //   data => {
    //     this.user.id = data['id'];
    //   },
    //   error => {
    //     this._flashMessagesService.show('Error in the Data/Server', { cssClass: 'alert-danger' });
    //   });
  }

  resetPassword() {
    this.loginservice.resetPassword(this.user)
      .subscribe(
        data => {
          if (data['status'] === 'success') {
            this._flashMessagesService.show(data['message'], { cssClass: 'alert-success' });
          } else {
            this._flashMessagesService.show(data['message'], { cssClass: 'alert-danger' });
          }
        },
        error => {
          alert('Network Error resetPassword API');
          this._flashMessagesService.show('Error in the Data/Server', { cssClass: 'alert-danger' });
        });
  }

}



// WEBPACK FOOTER //
// ./src/app/resetpassword/resetpassword.component.ts